import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["openIcon", "closeIcon", "mobileMenu"];

  toggle() {
    this.mobileMenuTarget.classList.toggle("hidden");
    this.mobileMenuTarget.classList.toggle("flex");

    this.openIconTarget.classList.toggle("hidden");
    this.openIconTarget.classList.toggle("inline-flex");

    this.closeIconTarget.classList.toggle("hidden");
    this.closeIconTarget.classList.toggle("inline-flex");
  }
}
